module.exports = __webpack_public_path__ + "static/media/icon-sneaker.d73e53b0.svg";